// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-header {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 8px;
}
.account-header .row {
  margin-bottom: 6px;
}
.gross-highlight {
  font-size: 18px;
  font-weight: 700;
  color: #2e7d32;
}
.balance-highlight {
  font-size: 18px;
  font-weight: 700;
  color: #2e3a7a;
}
.balance-highlight small {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: #777;
}
.gross-monthly-section {
  margin: 10px 0;
}
.row .col label {
  color: #4b58a6;
  font-weight: bold;
  padding-right: 3%;
}
h2 {
  background: #e1dbe2;
  margin: 0;
  padding: 15px;
  font-size: 16px;
  font-weight: 400;
  justify-content: space-between;
  align-items: center;
}
h2.collapsible-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
h2.collapsible-header:hover {
  background: #d5ced7;
}
h3 {
  font-size: 14px;
  font-weight: 600;
  color: #4b58a6;
  margin: 10px 0 6px;
}
.no-streams {
  padding: 16px;
  color: #888;
  font-style: italic;
}
.income-stream-card {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin: 10px 0;
  background: #fff;
}
.income-stream-card.inactive {
  opacity: 0.75;
  border-color: #e0e0e0;
}
.stream-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  cursor: pointer;
  background: #f5f3f7;
  border-bottom: 1px solid #eee;
}
.stream-header:hover {
  background: #eae6ee;
}
.stream-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.stream-name {
  font-weight: 600;
  font-size: 15px;
}
.expand-icon {
  font-size: 16px;
  color: #666;
}
.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.badge-active {
  background: #d4edda;
  color: #155724;
}
.badge-inactive {
  background: #f8d7da;
  color: #721c24;
}
.confidence-high {
  background: #d4edda;
  color: #155724;
}
.confidence-medium {
  background: #fff3cd;
  color: #856404;
}
.confidence-low {
  background: #f8d7da;
  color: #721c24;
}
.estimate-high {
  background: #cce5ff;
  color: #004085;
}
.estimate-medium {
  background: #fff3cd;
  color: #856404;
}
.estimate-low {
  background: #f8d7da;
  color: #721c24;
}
.stream-metrics {
  display: flex;
  gap: 16px;
  padding: 12px 14px;
  flex-wrap: wrap;
  border-bottom: 1px solid #f0f0f0;
}
.metric {
  flex: 1;
  min-width: 120px;
}
.metric-label {
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.metric-value {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.monthly-breakdown {
  padding: 10px 14px;
  border-bottom: 1px solid #f0f0f0;
}
.month-bars {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.month-bar {
  flex: 1;
  min-width: 100px;
  background: #f0ecf3;
  border-radius: 4px;
  padding: 8px 10px;
  text-align: center;
}
.month-label {
  font-size: 12px;
  color: #666;
}
.month-value {
  font-size: 15px;
  font-weight: 600;
  color: #4b58a6;
}
.month-total {
  margin-top: 8px;
  font-size: 13px;
  color: #555;
}
.stream-transactions {
  padding: 10px 14px;
}
.stream-transactions table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.stream-transactions table thead th {
  background: #f5f3f7;
  padding: 6px 8px;
  text-align: left;
  font-weight: 600;
  border-bottom: 2px solid #dee2e6;
}
.stream-transactions table tbody tr {
  border-bottom: 1px solid #f0f0f0;
}
.stream-transactions table tbody tr:hover {
  background: #fafafa;
}
.stream-transactions table td {
  padding: 5px 8px;
}
.text-right {
  text-align: right;
}
.text-capitalize {
  text-transform: capitalize;
}
.text-danger {
  color: #dc3545;
  font-weight: bold;
}
.inactive-section {
  margin-top: 12px;
}
.stream-summary-inline {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 13px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/income-stream-components/bank-account-sync/bank-account-sync.component.less"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AADJ;AAHA;EAOQ,kBAAA;AADR;AAKA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAHJ;AAMA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAJJ;AACA;EAMQ,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAJR;AAQA;EACI,cAAA;AANJ;AASA;EACI,cAAA;EACA,iBAAA;EACA,iBAAA;AAPJ;AAUA;EACI,mBAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AARJ;AAWA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AATJ;AAWI;EACI,mBAAA;AATR;AAaA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAXJ;AAcA;EACI,aAAA;EACA,WAAA;EACA,kBAAA;AAZJ;AAgBA;EACI,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAdJ;AAgBI;EACI,aAAA;EACA,qBAAA;AAdR;AAkBA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AAhBJ;AAkBI;EACI,mBAAA;AAhBR;AAoBA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAlBJ;AAqBA;EACI,gBAAA;EACA,eAAA;AAnBJ;AAsBA;EACI,eAAA;EACA,WAAA;AApBJ;AAwBA;EACI,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAtBJ;AAyBA;EACI,mBAAA;EACA,cAAA;AAvBJ;AA0BA;EACI,mBAAA;EACA,cAAA;AAxBJ;AA2BA;EACI,mBAAA;EACA,cAAA;AAzBJ;AA4BA;EACI,mBAAA;EACA,cAAA;AA1BJ;AA6BA;EACI,mBAAA;EACA,cAAA;AA3BJ;AA8BA;EACI,mBAAA;EACA,cAAA;AA5BJ;AA+BA;EACI,mBAAA;EACA,cAAA;AA7BJ;AAgCA;EACI,mBAAA;EACA,cAAA;AA9BJ;AAkCA;EACI,aAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AAhCJ;AAmCA;EACI,OAAA;EACA,gBAAA;AAjCJ;AAoCA;EACI,eAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAlCJ;AAqCA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAnCJ;AAuCA;EACI,kBAAA;EACA,gCAAA;AArCJ;AAwCA;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAtCJ;AAyCA;EACI,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAvCJ;AA0CA;EACI,eAAA;EACA,WAAA;AAxCJ;AA2CA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAzCJ;AA4CA;EACI,eAAA;EACA,eAAA;EACA,WAAA;AA1CJ;AA8CA;EACI,kBAAA;AA5CJ;AA2CA;EAIQ,WAAA;EACA,yBAAA;EACA,eAAA;AA5CR;AAsCA;EASY,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;AA5CZ;AA+BA;EAiBY,gCAAA;AA7CZ;AA+CY;EACI,mBAAA;AA7ChB;AAyBA;EAyBY,gBAAA;AA/CZ;AAoDA;EACI,iBAAA;AAlDJ;AAqDA;EACI,0BAAA;AAnDJ;AAsDA;EACI,cAAA;EACA,iBAAA;AApDJ;AAwDA;EACI,gBAAA;AAtDJ;AAyDA;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAvDJ","sourcesContent":["@import (reference) url('../../../../styles.less');\n\n.account-header {\n    background: #f8f9fa;\n    padding: 12px;\n    border-radius: 4px;\n    margin-bottom: 8px;\n\n    .row {\n        margin-bottom: 6px;\n    }\n}\n\n.gross-highlight {\n    font-size: 18px;\n    font-weight: 700;\n    color: #2e7d32;\n}\n\n.balance-highlight {\n    font-size: 18px;\n    font-weight: 700;\n    color: #2e3a7a;\n\n    small {\n        display: block;\n        font-size: 11px;\n        font-weight: 500;\n        color: #777;\n    }\n}\n\n.gross-monthly-section {\n    margin: 10px 0;\n}\n\n.row .col label {\n    color: #4b58a6;\n    font-weight: bold;\n    padding-right: 3%;\n}\n\nh2 {\n    background: #e1dbe2;\n    margin: 0;\n    padding: 15px;\n    font-size: 16px;\n    font-weight: 400;\n    justify-content: space-between;\n    align-items: center;\n}\n\nh2.collapsible-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n\n    &:hover {\n        background: #d5ced7;\n    }\n}\n\nh3 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #4b58a6;\n    margin: 10px 0 6px;\n}\n\n.no-streams {\n    padding: 16px;\n    color: #888;\n    font-style: italic;\n}\n\n// Income stream cards\n.income-stream-card {\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n    margin: 10px 0;\n    background: #fff;\n\n    &.inactive {\n        opacity: 0.75;\n        border-color: #e0e0e0;\n    }\n}\n\n.stream-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    cursor: pointer;\n    background: #f5f3f7;\n    border-bottom: 1px solid #eee;\n\n    &:hover {\n        background: #eae6ee;\n    }\n}\n\n.stream-title {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.stream-name {\n    font-weight: 600;\n    font-size: 15px;\n}\n\n.expand-icon {\n    font-size: 16px;\n    color: #666;\n}\n\n// Badges\n.badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.badge-active {\n    background: #d4edda;\n    color: #155724;\n}\n\n.badge-inactive {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.confidence-high {\n    background: #d4edda;\n    color: #155724;\n}\n\n.confidence-medium {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.confidence-low {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n.estimate-high {\n    background: #cce5ff;\n    color: #004085;\n}\n\n.estimate-medium {\n    background: #fff3cd;\n    color: #856404;\n}\n\n.estimate-low {\n    background: #f8d7da;\n    color: #721c24;\n}\n\n// Metrics row\n.stream-metrics {\n    display: flex;\n    gap: 16px;\n    padding: 12px 14px;\n    flex-wrap: wrap;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.metric {\n    flex: 1;\n    min-width: 120px;\n}\n\n.metric-label {\n    font-size: 11px;\n    color: #888;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.metric-value {\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n// Monthly breakdown\n.monthly-breakdown {\n    padding: 10px 14px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.month-bars {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.month-bar {\n    flex: 1;\n    min-width: 100px;\n    background: #f0ecf3;\n    border-radius: 4px;\n    padding: 8px 10px;\n    text-align: center;\n}\n\n.month-label {\n    font-size: 12px;\n    color: #666;\n}\n\n.month-value {\n    font-size: 15px;\n    font-weight: 600;\n    color: #4b58a6;\n}\n\n.month-total {\n    margin-top: 8px;\n    font-size: 13px;\n    color: #555;\n}\n\n// Transaction tables\n.stream-transactions {\n    padding: 10px 14px;\n\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        font-size: 13px;\n\n        thead th {\n            background: #f5f3f7;\n            padding: 6px 8px;\n            text-align: left;\n            font-weight: 600;\n            border-bottom: 2px solid #dee2e6;\n        }\n\n        tbody tr {\n            border-bottom: 1px solid #f0f0f0;\n\n            &:hover {\n                background: #fafafa;\n            }\n        }\n\n        td {\n            padding: 5px 8px;\n        }\n    }\n}\n\n.text-right {\n    text-align: right;\n}\n\n.text-capitalize {\n    text-transform: capitalize;\n}\n\n.text-danger {\n    color: #dc3545;\n    font-weight: bold;\n}\n\n// Inactive section\n.inactive-section {\n    margin-top: 12px;\n}\n\n.stream-summary-inline {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    font-size: 13px;\n    color: #666;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
